
export const text ={
    heading1:"font-heading font-bold text-2xl text-secondary-500",
    heading2:"font-heading text-2xl text-secondary-500 tracking-tight",
    description1:"font-body font-regular text-xs text-secondary-500 ",
}

export const input ={
    default:`rounded-md w-80 h-12 p-4  ${text.description1}`,
}

export const button ={
    default:`rounded-md w-32 h-12 bg-primary-500 active:bg-secondary-500 justify-center items-center`,
    text:`font-heading font-bold text-md text-white text-center uppercase`,
}
